import {Close} from '@mui/icons-material'
import {LoadingButton} from '@mui/lab'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material'
import React, {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

type ConfirmationDialogProps = {
  onClose: () => void
  onDeleteSingle: () => void
  onDeleteSeries?: () => void
  title?: string
  text?: string | ReactNode
  isSeriesItem: boolean
  isSingleLoading?: boolean
  isSeriesLoading?: boolean
  onlyDeleteSeries?: boolean
  additionalMessage?: string
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (props) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)

  return (
    <Dialog data-test-id="event-delete-modal" onClose={props.onClose} open>
      <DialogTitle>{t('action.delete')}</DialogTitle>
      {props.title && (
        <DialogContent>
          <Typography gutterBottom>
            {t('shiftEvent.sureToDelete')}: <b>{props.title}</b>
          </Typography>
          {props.additionalMessage && (
            <Typography
              sx={props.isSeriesItem ? () => ({opacity: '25%'}) : () => ({opacity: '100%'})}
            >
              {props.additionalMessage}
            </Typography>
          )}
        </DialogContent>
      )}
      {props.text && <DialogContent>{props.text}</DialogContent>}
      <DialogActions>
        <Button startIcon={<Close />} variant="text" onClick={props.onClose}>
          {t('action.cancel')}
        </Button>

        {!props.onlyDeleteSeries && (
          <LoadingButton
            loading={props.isSingleLoading}
            onClick={props.onDeleteSingle}
            data-test-id="event-single-delete-button"
            color="error"
            variant="text"
            sx={(theme) => ({boxShadow: theme.shadows[4]})}
          >
            {props.isSeriesItem
              ? t('shiftEvent.action.deleteEvent')
              : t('shiftEvent.action.delete')}
          </LoadingButton>
        )}

        {props.isSeriesItem && props.onDeleteSeries && (
          <LoadingButton
            loading={props.isSeriesLoading}
            onClick={props.onDeleteSeries}
            data-test-id="event-series-delete-button"
            color="error"
            variant="text"
            sx={(theme) => ({boxShadow: theme.shadows[4]})}
          >
            {t('shiftEvent.action.deleteSeries')}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  )
}
